import React, {useContext} from "react";
import {Box, FormControl, makeStyles, MenuItem, Select} from "@material-ui/core";
import Text from "../Text";
import {KeyboardArrowDown} from "@material-ui/icons";
import {Pagination} from "@material-ui/lab";
import {AppContext} from "../../../contexts/AppContext";
import {saveToStorage} from "../../../services/LocalStorage";
import {STORAGE_KEY_COMPLETED_TAB_ROWS_PER_PAGE} from "../../../helpers/Constants";

export function BottomPagination({pageCnt, currentPage, handlePageChange }) {
    const classes = useStyles();
    const { completedTabPageSize, setCompletedTabPageSize } = useContext(AppContext)

    const handlePageSizeChange = (event) => {
        saveToStorage(STORAGE_KEY_COMPLETED_TAB_ROWS_PER_PAGE, event.target.value)
        setCompletedTabPageSize(event.target.value)
    }

    return <Box height='70px' display='flex' justifyContent='space-between' alignItems='center' borderTop='1px solid #EDEDED' marginTop='10px' paddingTop='10px'>
        <Box display='flex' flex={1} color='black'>
            <Box display='flex' marginX={2} alignItems='center'>
                <Text style={{color:'#999CA6'}}>Rows per page:</Text>
                <FormControl style={{minWidth: 70}} size='small'>
                    <Select
                        value={completedTabPageSize}
                        type='outline'
                        disableUnderline
                        style={{margin: '0 10px'}}
                        onChange={handlePageSizeChange}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left"
                            },
                            getContentAnchorEl: null,
                            style: {
                                padding: 0
                            }
                        }}
                        IconComponent={KeyboardArrowDown}
                    >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={25}>25</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                    </Select>
                </FormControl>
            </Box>
        </Box>
        <Pagination
            className={classes.pagination}
            count={pageCnt ?? 1}
            variant="outlined"
            shape="rounded"
            page={currentPage ?? 1}
            color={"primary"}
            onChange={handlePageChange}/>
        <Box flex={1}/>
    </Box>
}

const useStyles = makeStyles(() => ({
    pagination: {
        display: "flex",
        flex: 1,
        justifyContent: "center",
        "& .MuiPaginationItem-icon": {
            color: "#4BB3EF"
        },
        '& .Mui-disabled .MuiPaginationItem-icon': {
            color: '#9B9EAB'
        },
        '& .MuiPaginationItem-outlinedPrimary': {
            border: 'none'
        },
        '& .MuiPaginationItem-outlinedPrimary.Mui-selected': {
            backgroundColor: "#4BB3EF",
            color: 'white',
            border: 'none',
        },
    }
}));
